/**
* Copyright Aquera Inc 2025
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import { css } from 'lit';

/** Enterprise (`--nile-*`) primary, NxtGen (`--ng-*`) fallback. */
export const styles = css`
:host {
  display: block;
}

.group {
  display: flex;
  flex-direction: column;
  gap: var(--nile-spacing-xs, var(--ng-spacing-xs));
}

:host([divider="false"]) .group {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.group-label {
  font-size: var(--nile-type-scale-3, var(--ng-font-size-text-sm));
  font-weight: var(--nile-font-weight-semibold, var(--ng-font-weight-semibold));
  text-transform: uppercase;
  color: var(--nile-colors-neutral-500, var(--ng-colors-text-disabled));
  margin: var(--nile-spacing-xs, var(--ng-spacing-xs)) 0 var(--nile-spacing-xs, var(--ng-spacing-xs)) var(--nile-spacing-md, var(--ng-spacing-md));
  letter-spacing: 0.05em;
}

.group-items {
  display: flex;
  flex-direction: column;
  gap: var(--nile-spacing-xs, var(--ng-spacing-xs));
}
`;

export default [styles];
